const storageKey = (workspaceId: string) => `gtm:last-project:${workspaceId}`

/**
 * Per-viewer convenience: the GTM project last opened in a workspace, so that
 * returning from Agents/Settings/Chats lands on the same project. The URL
 * (`?project=`) stays the source of truth whenever it is present.
 */
export function getLastGtmProjectId(workspaceId: string): string | null {
  try {
    return window.localStorage.getItem(storageKey(workspaceId))
  } catch {
    return null
  }
}

export function setLastGtmProjectId(workspaceId: string, projectId: string) {
  try {
    window.localStorage.setItem(storageKey(workspaceId), projectId)
  } catch {
    // Storage can be unavailable (private mode); the URL still carries it.
  }
}

/** URL project → last opened project → first project of the workspace. */
export function resolveGtmProject<T extends { id: string }>(
  projects: Array<T> | undefined,
  workspaceId: string,
  requestedProjectId: string | undefined,
): T | undefined {
  if (!projects?.length) return undefined
  const lastProjectId = getLastGtmProjectId(workspaceId)
  return (
    projects.find((item) => item.id === requestedProjectId) ??
    projects.find((item) => item.id === lastProjectId) ??
    projects[0]
  )
}
